import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class CorporateService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  addCorporateLead(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-update-corporate-lead',data,{headers:webheader})
  }

  getCorporateLeadFormData(corporate_lead_id)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-corporate-lead-form-data/'+corporate_lead_id,{headers:webheader});
  }

  getleadCorporateLists(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-corporate-lead-lists/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  getInsuranceLeadsStatus()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-insurance-leads-status/',{headers:webheader})
  }

  getCorporateLeadsForsheetview(pageno:number,limit:number,qString:string){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-corporate-lead-lists/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
  }

  UpdateCorporateLeadsFromSheetview(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.put(apiUrl+'update-corporate-lead-sheetview',data,{headers:webheader})
  }

  getCommonData()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-common-data-of-corporate',{headers:webheader})
  }

  getCorporateStatusLists()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-corporate-status-lists',{headers:webheader})
  }

  nimbusClickTOCallForCorporateLeads(lead_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'nimbus-click-to-call-for-corporate-leads',lead_id,{headers:webheader})
  }
}
